<template>
  <div :class="{'is-stories':$isEngCom}">
    <div v-if="!edit" class="tags-wrapper is-flex gtm-category-tag">
      <a v-for="tag in projectTags" :key="tag.name" tabindex="0" @keypress.enter.space="clickTag(tag)" @click="clickTag(tag)" class="a-tag gtm-category-tag">
        <span v-if="hidingysctags(tag.name)" tabindex="0" class="tag is-flex gtm-category-tag">{{ $isEngCom ? tag.name : '# ' + tag.name }}</span>
      </a>
    </div>
    <div v-if="edit">
      <tag-selector class="edit-tags gtm-category-tag"
                    v-model="tagSelector"
                    :chosenTags="chosenTags" />
    </div>
  </div>
</template>

<script>

import TagSelector from '@/components/Inputs/TagSelector'

export default {

  props: ['project', 'edit', 'tagsysc'],

  components: {
    TagSelector
  },

  data: function () {
    return {
      tagSelector: '',
      chosenTags: [],
      projectType: ''
    }
  },

  watch: {
    chosenTags: function () {
      this.$emit('updateChosenTags', this.chosenTags)
    },
    projectTags: function () {
      const tags = this.project.tags || []
      this.chosenTags = tags.map(function (item) {
        return item.name
      })
      if (this.$isYSC === 'ysc' && this.tagsysc) {
        this.chosenTags = this.chosenTags.concat(this.tagsysc)
      }
    }
  },
  mounted: function () {
    if (!this.project) {
      return
    }
    this.projectType = this.project.type
    this.hasChosenTags(this.project.id)
  },

  computed: {
    projectTags: function () {
      if (this.project && this.project.tags && this.project.tags.length > 0) {
        return this.project.tags
      }
    }
  },

  methods: {
    hasChosenTags: function (projectID) {
      const { tags } = this.$store.getters.project(projectID)
      if (tags && projectID) {
        tags.map(tag => {
          this.chosenTags.push(tag.name)
        })
      }
    },
    clickTag: function (tag) {
      this.$router.push({ name: 'viewAll', query: { tag: encodeURIComponent(tag.name) } })
    },
    hidingysctags: function (tagname) {
      if (tagname === 'Safety' || tagname === 'humanlowrisk' || tagname === 'humansignificantrisk' || tagname === 'animaluse') {
        return false
      } else {
        return true
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  /* Tags */
  .tags-wrapper{
    justify-content: flex-start;
    flex-wrap: wrap;
    .a-tag {
      display: inline-block;
      height: inherit;
    }
    .tag {
      margin: 0.15rem 0.3rem 0.15rem 0;
      font-size: 0.6rem;
      margin-bottom: 0.3rem;
      border: 1px solid $grey-light;
      background-color: transparent;
      border-radius: 2px;
    }
  }
  .tags .tag {
    margin-bottom: 0;
  }

  .edit-tags {
    width: 100%;
  }

  .is-stories {
    .tag {
      background-color: $white;
      color: $dark;
      border: 1px solid $grey;
      border-radius: 3px;
      font-size: 0.75rem;
      text-transform: capitalize;
    }
  }
</style>
